<ion-header>
  <ion-toolbar>
    <!-- Back icon and Close button -->
    <ion-button slot="end" class="close-btn" (click)="goBack()">{{CloseText}}</ion-button>
    <div class="back-icon" (click)="goBack()">
      <ion-icon name="arrow-back"></ion-icon>
    </div>

    <!-- Title -->
    <ion-title class="ion-text-center">
      <div class="header-content">
        Live chat
      </div>
    </ion-title>
  </ion-toolbar>
</ion-header>